module.exports = __webpack_public_path__ + "static/media/PL.d20fd92b.png";